<template>
  <div>
    <div className="sub-title">
      获取浏览器基本信息示例
    </div>
    <div v-if="mobileInfo">
      {{mobileInfo}}
    </div>
    <div v-if="mobileModel">
      <div className={styles.textLabel}>
        系统: {{mobileModel.os}}
      </div>
      <div className={styles.textLabel}>
        系统的版本号: {{mobileModel.version}}
      </div>
      <div className={styles.textLabel}>
        设备型号: {{mobileModel.model}}
      </div>
    </div>
    <div v-if="md">
      <div className={styles.textLabel}>
        {{`md.mobile() -> ${md.mobile()}`}}
      </div>
      <div className={styles.textLabel}>
        {{`md.phone() -> ${md.phone()}`}}
      </div>
      <div className={styles.textLabel}>
        {{`md.userAgent() -> ${md.userAgent()}`}}
      </div>
      <div className={styles.textLabel}>
        {{`md.os() -> ${md.os()}`}}
      </div>
      <div className={styles.textLabel}>
        {{`md.version('Webkit') -> ${md.version('Webkit')}`}}
      </div>
      <div className={styles.textLabel}>
        {{`md.maxPhoneWidth -> ${md.maxPhoneWidth}`}}
      </div>
    </div>
  </div>
</template>

<script>
  import MobileDetect from 'mobile-detect';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      mobileInfo: null,
      mobileModel: null,
      md: null,
    }
  },
  methods: {
      getUserAgent() {
        // const userAgentInfo = navigator.userAgent;
        // const md = new MobileDetect(userAgentInfo);
        

        //判断数组中是否包含某字符串  
        Array.prototype.contains = function(needle) {  
            for (i in this) {  
              console.log('this[i]', this[i]);
                if (typeof(this[i]) == 'string' && this[i].indexOf(needle) > 0)  
                    return i;  
            }  
            return -1;  
        }  
        const deviceType = navigator.userAgent;//获取userAgent信息 
        this.mobileInfo = deviceType;
        const md = new MobileDetect(deviceType);//初始化mobile-detect  
        var os = md.os();//获取系统  
        var version = "";//系统的版本号   
        var model = "";  //设备型号
        if (os == "iOS") {//ios系统的处理  
            version =  md.version("iPhone");
            os = md.os();  
            model = md.mobile();  
        } else if (os == "AndroidOS") {//Android系统的处理  
            os = md.os();  
            version = md.version("Android");
            var sss = deviceType.split(";");  
            var i = sss.contains("Build/");  
            if (i > -1) {  
                model = sss[i].substring(0, sss[i].indexOf("Build/"));  
            }  
        }  
        //组装信息
        var info = {
          os:os,//系统类型
          version:version,//系统版本号
          model:model //设备型号
        };
        console.log('mobileInfo====', deviceType);
        console.log('info====', info)
        console.log('md====', md)
        this.mobileModel = info;
        this.md = md;
      }

    },

    mounted(){
      this.getUserAgent();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped >
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue